import { AnalyticsEvent } from '@/core/analytics/events/AnalyticsEvent.ts'

interface DatagridSortingEventProps extends Record<string, unknown> {
  type: 'cost' | 'units' | 'alphabetically'
}

class DatagridSortingEvent extends AnalyticsEvent {
  constructor(props: DatagridSortingEventProps) {
    super('Datagrid Sorting', props)
  }
}

export { DatagridSortingEvent }
